import React from 'react';
import {Link} from "react-router";
import { ImTarget } from "react-icons/im";
import sizmek from "../assets/sizmek.png";

function Hedefleme(props) {
    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
          <span className="breadcumb__title">
            <span className="breadcumb__title" style={{color:"#0a0a0a"}}>HEDEFLEME</span> SEÇENEKLERİMİZ
          </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            {" "}
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>{" "}
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">HEDEFLEME SEÇENEKLERİMİZ</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="about-us py-120">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-md-4 ">
                            <div className="about-left">
                                <img src="assets/images/thumb/about-img-01.png" alt=""/>

                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="section-heading style-two">

                                <h2 className="section-heading__title">
                                    <span
                                        className="section-heading__title-colored"> Doğru Ses, Doğru Kulağa</span>{" "}
                                </h2>
                                <p className="section-heading__desc">

                                    <b> 🎯 Dijital Audio Reklamcılıkta Hedefleme Seçenekleri</b><p/><br/>

                                    Markanızı doğru kulağa ulaştırın.
                                    Dijital ses reklamları, hedef kitlenizle daha yakın, daha kişisel bir bağ
                                    kurmanın en etkili yollarından biridir. Peki reklamlarınızı kimlerin duyacağını
                                    nasıl kontrol edersiniz? İşte sunduğumuz gelişmiş hedefleme seçenekleriyle
                                    tanışın:
                                    <p/>

                                    <br/>
                                    <b>👥 Demografik Hedefleme</b><p/><br/>

                                    Reklamlarınızı yaş, cinsiyet ve medeni durum gibi kriterlere göre yönlendirin.
                                    <p/>
                                    • Yaş gruplarına özel kampanyalar<p/>
                                    • Kadın/erkek ağırlıklı ürün/hizmetler için filtreleme<p/>
                                    • Aile veya genç yetişkin segmentasyonları<p/>


                                    <p/>
                                    <br/>
                                    <b>🌍 Lokasyon Bazlı Hedefleme</b><p/><br/>

                                    <p/>
                                    Reklamlarınız, kullanıcıların bulunduğu konuma göre yayınlanır. <p/>
                                    • İl / ilçe / bölge bazında hedefleme<p/>
                                    • GPS verisiyle hiper-lokal kampanyalar<p/>
                                    • Seyahat eden kullanıcılara özel dinamik içerikler<p/>


                                    <p/>   <br/>
                                    <b> 🕒 Zamanlama (Dayparting)</b><p/><br/>

                                    <p/>
                                    Reklamlarınızı günün belirli saatlerinde ya da haftanın belirli günlerinde
                                    yayınlayarak, erişiminizi maksimum etkiye ulaştırın. <p/>
                                    • Sabah işe gidiş saatlerinde duyulan kampanyalar <p/>
                                    • Hafta sonuna özel teklifler <p/>
                                    • Öğle arası promosyonları <p/>


                                    <p/>
                                    <br/>
                                    <b> 🎧 Dinleyici Davranışı ve Platform Hedefleme</b><p/><br/>

                                    Dinleyicilerin müzik tercihleri, dinleme zamanı ve kullandıkları platformlara
                                    göre hedefleme. <p/>
                                    • Networkumuzdeki tüm radyo ve uygulamalarda reklam <p/>
                                    • Podcast dinleyicilerine özel reklam stratejileri <p/>
                                    • Müzik türüne göre hedefleme (Pop, Rock, Klasik, Elektronik vs.) <p/>


                                    <p/>
                                    <br/>
                                    <b> 🧠 İlgi Alanı ve Yaşam Tarzı Hedeflemesi</b><p/><br/>


                                    Kullanıcıların ilgi alanları, alışkanlıkları ve yaşam tarzlarına göre filtreleme
                                    yapılabilir. <p/>
                                    • Spor meraklılarına özel içerikler <p/>
                                    • Sağlık ve wellness odaklı dinleyicilere kampanyalar <p/>
                                    • Teknoloji, otomotiv, finans gibi dikeylerde hedefleme <p/>

                                    <br/>

                                    <p/>
                                    <b> 📲 Cihaz ve Uygulama Hedeflemesi</b><p/><br/>

                                    <p/>
                                    Reklamlarınızı sadece mobil, tablet ya da masaüstü kullanıcılarına gösterebilir;
                                    belirli uygulamalar veya işletim sistemlerine özel yayın yapabilirsiniz. <p/>
                                    • iOS / Android ayrımı <p/>
                                    • Kulaklıkla dinleme anlarında özel mesajlar <p/>
                                    • Akıllı hoparlör kullanıcılarına erişim <p/>


                                    <p/>
                                    <br/>
                                    <b> 📈 Yeniden Hedefleme (Retargeting)</b><p/><br/>

                                    <p/>
                                    Markanızla daha önce etkileşime geçmiş dinleyicileri yeniden yakalayın. <p/>
                                    • Önceki kampanyalarınıza tepki veren kullanıcılar <p/>
                                    • Web sitenizi ziyaret etmiş ama dönüşüm gerçekleştirmemiş dinleyiciler <p/>
                                    • CRM listenize entegre hedefleme seçenekleri <p/>


                                    <p/>
                                    <br/>
                                    <b> 📊 Segmentasyon + Dinamik Kreatif</b><p/><br/>


                                    Dinleyicilere özel, otomatik olarak uyarlanan içeriklerle kişiselleştirilmiş
                                    reklam deneyimi. <p/>
                                    • Yaşa ve bölgeye göre değişen reklam seslendirmeleri<p/>
                                    • Gerçek zamanlı hava durumu ya da etkinlik verisine dayalı içerikler<p/>
                                    • Kullanıcı davranışına göre optimize edilen ses mesajları<p/>


                                    <p/>
                                    <br/>
                                    Sonuç: <strong>“Doğru Ses, Doğru Kulağa”</strong> <p/>

                                    Dijital audio reklamlar, hem duygusal bağ kurar hem de doğru hedeflemeyle
                                    maksimum dönüşüm sağlar. <p/>
                                    Biz, markanızı sadece “dinletmiyoruz”, aynı zamanda etkili dinlenmesini
                                    sağlıyoruz. <p/>
                                    hakim profesyonel bir kadroya sahip olan Audiotime, sektörde sınanmış
                                    tecrübesine ek olarak yeni nesil teknolojiler ile radyo ve ses reklamcılığının
                                    en inovatif projelerine imza atmayı hedeflemektedir.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
          
        </React.Fragment>
    );
}

export default Hedefleme;